import OperatorInactive from "./OperatorInactive";

export default OperatorInactive